import { diff } from 'deep-object-diff';
import { isInTestMode } from './is-in-test-mode';

let lastState;

export const TestModeMiddleware = (api) => (next) => (action) => {
  const response = next(action);
  if (!isInTestMode()) {
    return response;
  }
  lastState = api.getState();
  return response;
};

window.testModeGetState = () => {
  if (!isInTestMode()) {
    return {};
  }
  return lastState;
};

const sanitizeState = (state) => {
  const stateClone = JSON.parse(JSON.stringify(state));
  stateClone.entities = {
    ...stateClone.entities,
    fulfillmentPlans: Object.fromEntries(
      Object.entries(stateClone.entities.fulfillmentPlans).map(([k, v]) => {
        return [
          k,
          {
            ...v,
            lastLoadedDateTime: '',
          },
        ];
      }),
    ),
    salesOrders: Object.fromEntries(
      Object.entries(stateClone.entities.fulfillmentPlans).map(([k, v]) => {
        return [
          k,
          {
            ...v,
            lastLoadedDateTime: '',
          },
        ];
      }),
    ),
  };
  delete stateClone.labelQue.fromProcessDate;
  delete stateClone.seller.users[0].lastLoginDate;
  delete stateClone.user.currentUser.lastLoginDate;
  delete stateClone.shipments.filtering.defaultFilterView.appliedFilters;
  delete stateClone.seller.data.planInfo.usage;
  delete stateClone.featureFlags;
  return stateClone;
};

const removeEmpty = (obj) => {
  if (!obj) {
    return;
  }
  return Object.fromEntries(
    Object.entries(obj)
      .filter((entry) => JSON.stringify(entry[1]) !== '{}')
      .map(([k, v]) => [k, typeof v === 'object' ? removeEmpty(v) : v]),
  );
};

window.testModeGetDiff = (expectedState) => {
  const sanitizedExpectedState = sanitizeState(expectedState);
  const sanitizedLastState = sanitizeState(lastState);
  const rawDiff = diff(sanitizedExpectedState, sanitizedLastState);
  let previousEmpty = removeEmpty(rawDiff);
  let newEmpty = removeEmpty(removeEmpty(rawDiff));
  while (JSON.stringify(newEmpty) !== JSON.stringify(previousEmpty)) {
    previousEmpty = newEmpty;
    newEmpty = removeEmpty(newEmpty);
  }
  return newEmpty;
};
